import { defineMessages } from 'react-intl';

export default defineMessages({
    dataPrivacy: {
        id: 'app.signup.additionalConsentsInstructions.dataPrivacy',
        defaultMessage: 'Data privacy and information security at Alva'
    },
    seriously: {
        id: 'app.signup.additionalConsentsInstructions.seriously',
        defaultMessage: 'We take your privacy seriously'
    },
    seriouslyDescription: {
        id: 'app.signup.additionalConsentsInstructions.seriouslyDescription',
        defaultMessage: 'We designed and developed our platform from the ground up to put you in full control of your privacy.'
    },
    protect: {
        id: 'app.signup.additionalConsentsInstructions.protect',
        defaultMessage: 'How Alva Labs protects you'
    },
    protectDescription: {
        id: 'app.signup.additionalConsentsInstructions.protectDescription',
        defaultMessage: 'We’ve built powerful controls and options so you can manage your privacy and access to your data'
    },
    control: {
        id: 'app.signup.additionalConsentsInstructions.control',
        defaultMessage: 'You are in control'
    },
    controlDescription: {
        id: 'app.signup.additionalConsentsInstructions.controlDescription',
        defaultMessage: 'At all times, you have transparency to where, when and who has access to your data.'
    }
});
